<template>
  <div id="editprofile" class="tab-pane active tab-box">
    <div class="profile-pic-wrapper">
  <div class="pic-holder">
    <!-- uploaded pic shown here -->
    <img v-if="$auth && $auth.user" id="profilePic" class="pic" :src="profile.user_profile" @error="imageErrorHandle">
    <Input class="uploadProfileInput" type="file" name="profile_pic" id="newProfilePhoto" accept="image/*" style="opacity: 0;" @change="uploadImage"/>
    <label for="newProfilePhoto" class="upload-file-block">
      <div class="text-center">
        <div class="mb-2">
          <i class="fa fa-camera fa-2x"></i>
        </div>
        <div class="text-uppercase">
          Update <br /> Profile Photo
        </div>
      </div>
    </label>
  </div>
</div>
    <div class="mt-4">
      <div class="mt-4 position-relative">
        <h6 class="mb-2">{{ $t('First Name') }}</h6>
        <input
          class="form-control mb-0 h50"
          type="text"
          :placeholder="$t('First Name')"
          aria-label="Name"
          v-model="$v.profile.user_name.$model"
          :class="{
            'is-invalid': $v.profile.user_name.$error,
          }"
        />
        <div v-if="$v.profile.user_name.$error" class="invalid-feedback">
          <span v-if="!$v.profile.user_name.required"
            >{{ $t('Please enter field',{msg:$t('First Name')}) }}</span
          >
        </div>
      </div>
      <div class="mt-4 position-relative">
        <h6 class="mb-2">{{ $t('Last Name') }}</h6>
        <input
          class="form-control mb-0 h50"
          type="text"
          :placeholder="$t('Last Name')"
          aria-label="Last Name"
          v-model="$v.profile.last_name.$model"
          :class="{
            'is-invalid': $v.profile.last_name.$error,
          }"
        />
        <div v-if="$v.profile.last_name.$error" class="invalid-feedback">
          <span v-if="!$v.profile.last_name.required"
            >{{ $t('Please enter field',{msg:$t('Last Name')}) }}</span
          >
        </div>
      </div>
      <div class="mt-4 position-relative">
        <h6 class="mb-2">{{ $t('Email Address') }}</h6>
        <input
          class="form-control mb-0 h50"
          type="text"
          :placeholder="$t('Email')"
          aria-label="Email"
          v-model="$v.profile.user_email.$model"
          :class="{
            'is-invalid': $v.profile.user_email.$error,
          }"
        />
        <div v-if="$v.profile.user_email.$error" class="invalid-feedback">
          <span v-if="!$v.profile.user_email.required">{{ $t('Please enter email') }}</span>
          <span v-if="!$v.profile.user_email.email"
            >{{ $t('This value should be a valid email') }}</span
          >
        </div>
      </div>
      <input type="hidden" v-model="profile.country_code">
      <div class="mt-4 position-relative">
        <h6 class="mb-2">{{ $t('Phone Number') }}</h6>
        <input
          class="form-control mb-0 h50"
          type="text"
          placeholder="Phone"
          aria-label="Phone"
          v-model="profile.mobile_number"
          readonly
        />
      </div>
    </div>
    <div class="mt-4 position-relative" v-if="languageArray.length > 1">
      <h6 class="mb-2">{{ $t('Select Language') }}</h6>
       <select v-model="profile.is_langauge" class="custom-select" :class="'ccc'+profile.is_langauge">
          <option
            v-for="lang in languageArray"
            :key="lang.value"
            :class="lang.value == $store.state.lang.locale?'selected':''"
            :value="lang.value" :selected="lang.value == $store.state.lang.locale?'selected':''">{{lang.text}}
          </option>
        </select>
        <!-- <select class="custom-select" @change="languageChange" v-model="language" >
            <option :value="l.value" v-for="l in languages" :key="l.value">{{l.text}}</option>
          </select> -->
    </div>
    <div class="delivery-address border-0 mt-4">
      <div class="full-btn" id="editprofile">
        <button @click="editProfile" class="red-outline-btn">{{ $t('Update') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions} from 'vuex';
import { required, email} from "vuelidate/lib/validators";
import { getLanguageText,imageErrorHandle } from '../../helper/helper';

export default {  
  data() {
    return {
      imageErrorHandle,imageErrorHandle,
      profile: {
        user_email: "",
        user_name: "",
        last_name: "",
        mobile_number: "",
        country_code: "",
        is_langauge: "en",
        user_profile:"",
      },
      prim_lang : '',
      seco_lang : '',      
      language : '',
      languageArray: [],
      
    };
  },
  computed:{
    lang: {
      get: function() {
        return this.$store.state.lang.locale
      },
      set: function(newVal) {
        this.$store.dispatch('lang/changeLangLocale', newVal)
      }
    }
  },
  validations: {
    profile: {
      user_email: {
        required,
        email,
      },
      user_name: {
        required,
      },
      last_name: {
        required,
      },
    },
  },
  mounted() {    

    if (this.$auth.user && this.$auth.setting) {
      this.profile = {
        user_email: this.$auth.user.user_email,
        user_name: this.$auth.user.user_name,
        last_name: this.$auth.user.last_name,
        mobile_number : this.$auth.user.mobile_number,
        country_code : this.$auth.user.country_code,
        is_langauge : this.$store.state.lang.locale,
        user_profile:this.$auth.user.user_profile
      };
      this.languageArray = [       
        { 'value' : this.$auth.setting.primary_lang , text: getLanguageText(this.$auth.setting.primary_lang) },
      ];
      if (this.$auth.setting.secondary_lang) {
        this.languageArray.push({'value' : this.$auth.setting.secondary_lang, text: getLanguageText(this.$auth.setting.secondary_lang)});
      }
      this.prim_lang = this.$auth.setting.primary_lang,
      this.seco_lang = this.$auth.setting.secondary_lang
    } else {
      this.$router.push({ name: "sign-in" });
    }
  },
  methods: {
    ...mapActions("user",["updateUserDetails"]),
    uploadImage(e) {
      // let vm = this;
      var selectedFile = e.target.files[0]; 
      this.loading = true;
      this.is_btn_spinner = true;
      if (selectedFile) {
        this.profile.user_profile = selectedFile
        var oFReader = new FileReader();
        oFReader.readAsDataURL(document.getElementById("newProfilePhoto").files[0]);
        oFReader.onload = function (oFREvent) {
            document.getElementById("profilePic").src = oFREvent.target.result;
        };
      } else {
        console.error("No file selected");
      }
    },

    editProfile() {
      this.$v.$touch();
      if (this.$v.profile.$invalid) {
        return;
      } else {
        var formData = new FormData();
        formData.append("user_email",this.profile.user_email)
        formData.append("user_name",this.profile.user_name)
        formData.append("last_name",this.profile.last_name)
        formData.append("mobile_number",this.profile.mobile_number)
        formData.append("country_code",this.profile.country_code)
        formData.append("is_langauge",this.profile.is_langauge)
        formData.append("user_profile",this.profile.user_profile)

        this.updateUserDetails(formData).then((data) => {
          if (data.code == 200) {
            this.lang = this.profile.is_langauge;
            localStorage.setItem('localelang', this.profile.is_langauge);
            this.$auth.setUserDetails(data.user_details);
            this.profile = data.user_details
            this.$toasted.success(this.$t('Profile update successfully'), { duration: 2000 });
          } else {
            this.$toasted.success(data.msg, { duration: 2000 });
          }
        });
      }
    },
    languageChange() {
      localStorage.setItem('language',this.language);
    },
    
  },
};
</script>